/* Copy for the storytelling home page and the public shipment tracker.
   Merged over `translations` in LanguageContext (nav / hero are deep-merged). */

export const storyTranslations = {
  ar: {
    media: { dockAlt: "شاحنة تغادر رصيف التحميل في مستودعنا" },
    nav: { track: "تتبّع شحنتك" },
    hero: {
      kicker: "من تركيا والصين إلى سوريا",
      headline: ["طريقك الآمن", "للتجارة والشحن"],
      lede: "نستلم بضاعتك من المورّد، نجهّزها في مستودعاتنا، ونوصلها إلى دمشق وحلب. وتعرف مكانها في كل خطوة.",
      ctaTrack: "تتبّع شحنة",
      scroll: "مرّر لترى الرحلة",
    },
    track: {
      kicker: "تتبّع مباشر",
      title: "أين شحنتك الآن؟",
      subtitle: "أدخل رقم التتبّع المكوّن من ١٠ أرقام والموجود على إيصال الشحنة أو في رسالة واتساب.",
      label: "رقم التتبّع",
      placeholder: "0000000000",
      button: "تتبّع",
      searching: "نبحث عن شحنتك…",
      privacy: "تظهر التفاصيل لكل من يملك رقم التتبّع، فشاركه مع من تثق به فقط. لا نعرض أرقام الهواتف أو العناوين.",
      digitsHint: (n) => `${n} من ١٠ أرقام`,
      errors: {
        invalid: "رقم التتبّع يتكوّن من ١٠ أرقام بالضبط.",
        not_found: "لم نجد شحنة بهذا الرقم. تأكّد من الأرقام أو تواصل مع أقرب فرع.",
        rate_limited: "محاولات كثيرة خلال وقت قصير. حاول مجدداً بعد بضع دقائق.",
        error: "تعذّر الوصول إلى نظام التتبّع الآن. حاول بعد قليل أو اتصل بنا.",
      },
      result: {
        shipment: "الشحنة",
        current: "الحالة الآن",
        from: "من",
        to: "إلى",
        mode: "طريقة الشحن",
        eta: "الوصول المتوقّع",
        departed: "تاريخ الانطلاق",
        parcels: "الطرود",
        parcelsOf: (done, total) => `${done} من ${total} وصلت`,
        noParcels: "بانتظار الاستلام",
        lastUpdate: "آخر تحديث",
        trackAnother: "تتبّع رقماً آخر",
        copyLink: "نسخ رابط التتبّع",
        copied: "تم النسخ",
        cancelled: "أُلغيت هذه الشحنة",
        cancelledNote: "للاستفسار تواصل مع الفرع الذي سجّل الشحنة.",
        help: "لديك سؤال عن هذه الشحنة؟",
        whatsapp: "راسلنا على واتساب",
        domestic: "شحن داخلي",
        unknownCity: "يُحدَّد لاحقاً",
        pending: "يُحدَّد لاحقاً",
      },
      stages: ["تم التسجيل", "في مستودعنا", "في الطريق", "وصلت", "تم التسليم"],
      details: {
        registered: "مسجّلة، بانتظار وصول البضاعة إلى مستودعنا",
        received: "استُلمت وفُحصت في مستودعنا",
        ready_to_ship: "أُسندت إلى رحلة وجاهزة للانطلاق",
        loaded: "حُمّلت وأُغلقت استعداداً للانطلاق",
        departed: "انطلقت وهي في الطريق",
        at_border: "عند المعبر الحدودي",
        in_customs: "قيد التخليص الجمركي",
        arrived: "وصلت إلى مستودع الوجهة",
        delivered: "تم تسليم الشحنة",
      },
      modes: { road: "برّي", sea: "بحري", air: "جوي" },
      more: {
        sender: "المُرسِل",
        receiver: "المستلِم",
        reference: "رقم الشحنة",
        kind: "نوع الشحن",
        kinds: { road: "شحن برّي", sea_lcl: "بحري · حاوية مشتركة", sea_fcl: "بحري · حاوية كاملة", air: "شحن جوي" },
        payment: "الدفع",
        payStatus: { paid: "مدفوعة بالكامل", partial: "مدفوعة جزئياً", unpaid: "غير مدفوعة", pending: "التسعير قيد الإعداد", awaiting_confirmation: "بانتظار تأكيدك للسعر", cancelled: "ملغاة" },
        remaining: "المبلغ المتبقّي",
        allPaid: "لا يوجد مبلغ مستحق",
        pendingNote: "سنرسل لك السعر النهائي بعد استلام البضاعة ووزنها في مستودعنا.",
        awaitingNote: "تواصل معنا لتأكيد السعر النهائي حتى نكمل شحنتك.",
        paidOf: (paid, total) => `دُفع ${paid} من ${total}`,
        freight: "أجور الشحن",
        customs: "الرسوم الجمركية",
        customsEst: "تقديرية",
        customsActual: "فعلية",
        goodsAdvance: "قيمة بضاعة دُفعت عنك",
        other: "رسوم أخرى",
        total: "الإجمالي",
        paid: "المدفوع",
        credit: "رصيد لصالحك",
        dueBy: (d) => `يُستحق قبل ${d}`,
        payHelp: "للدفع أو الاستفسار عن الفاتورة",
        contents: "محتوى الشحنة",
        parcelsCount: (n) => (n === 1 ? "طرد واحد" : n === 2 ? "طردان" : n <= 10 ? `${n} طرود` : `${n} طرداً`),
        multiNote: (n) => `شحنتك مكوّنة من ${n} طرود، وتُتابَع معاً برقم تتبّع واحد.`,
        pieces: "قطعة",
        kg: "كغ",
        cbm: "م³",
        unspecified: "بضاعة متنوّعة",
        delivered: (d, n) => `سُلّم ${d} من ${n}`,
        showAll: (n) => `عرض كل الأصناف (${n})`,
        showLess: "عرض أقل",
        origin: "بلد المنشأ",
        cancelReason: "سبب الإلغاء",
      },
      demo: "للتجربة محلياً:",
    },
    journey: {
      kicker: "رحلة شحنتك",
      title: "مصدران، وجهة واحدة",
      chapters: [
        { k: "الاستلام", t: "نستلم من المورّد", d: "من مصانع الصين وأسواق إسطنبول، يستلم فريقنا بضاعتك ويطابقها مع فاتورتك." },
        { k: "المستودع", t: "نجمع ونغلّف", d: "نجمع طلباتك من عدّة موردين في شحنة واحدة، ونعيد تغليفها لحمايتها في كل مرحلة." },
        { k: "الطريق", t: "برّاً وبحراً وجوّاً", d: "برّاً من تركيا خلال ٥ إلى ٧ أيام، بحراً للحمولات الكبيرة، وجوّاً للشحنات العاجلة خلال ٢ إلى ١٠ أيام." },
        { k: "الجمارك", t: "تخليص بلا انتظار", d: "فريق تخليص متخصّص يجهّز الأوراق مسبقاً ليعبر شحنك الحدود دون تأخير." },
        { k: "التسليم", t: "في دمشق وحلب", d: "تصل بضاعتك إلى مستودعاتنا في دمشق وحلب، وتتابع كل خطوة برقم التتبّع." },
      ],
      cta: "تتبّع شحنتك",
      progress: "تقدّم الرحلة",
    },
    proof: {
      before: "منذ",
      years: "٩ سنوات",
      mid1: "سلّمنا أكثر من",
      shipments: "12,400",
      mid2: "شحنة عبر",
      routes: "18",
      mid3: "خطاً، لأكثر من",
      clients: "3,200",
      after: "عميل يثقون بنا.",
      ontime: "تسليم في الموعد",
    },
    cta: {
      title: "جاهز لشحنتك القادمة؟",
      body: "أخبرنا ماذا تشحن ومن أين، وسنرسل لك تسعيرة واضحة تشمل جميع الرسوم.",
      quote: "اطلب تسعيرة",
      whatsapp: "واتساب",
    },
    modesSection: {
      kicker: "طرق الشحن",
      title: "اختر كيف تسافر بضاعتك",
      lede: "لكل شحنة ظروفها. هذه مقارنة سريعة بين خياراتنا الثلاثة لتختار حسب ميزانيتك وموعدك.",
      labels: { route: "المسار", transit: "مدة الوصول", bestFor: "الأنسب لـ", cta: "اطلب سعراً لهذه الطريقة" },
      items: {
        road: { name: "برّي", route: ["إسطنبول", "حلب", "دمشق"], transit: "٥ إلى ٧ أيام", best: ["الطلبات المنتظمة من تركيا", "أقل تكلفة للكيلو", "بضائع مجمّعة من عدّة موردين"] },
        sea: { name: "بحري", route: ["الصين أو مرسين", "اللاذقية", "دمشق"], transit: "١٠ إلى ٣٥ يوماً", best: ["الحمولات الثقيلة والكبيرة", "حاوية كاملة أو مشتركة", "الاستيراد المباشر من الصين"] },
        air: { name: "جوي", route: ["إسطنبول أو الصين", "دمشق"], transit: "٢ إلى ١٠ أيام", best: ["الطلبات العاجلة", "البضائع الصغيرة عالية القيمة", "العيّنات وقطع الغيار"] },
      },
    },
    answers: {
      title: "إجابات سريعة",
      items: [
        { q: "كم يستغرق الشحن من تركيا إلى سوريا؟", a: "الشحن البرّي يستغرق عادة من ٥ إلى ٧ أيام من إسطنبول إلى دمشق أو حلب. الشحن الجوي من ٢ إلى ١٠ أيام، أما البحري فيأخذ وقتاً أطول لكنه أوفر للحمولات الثقيلة." },
        { q: "هل يمكنني الشحن من الصين إلى سوريا معكم؟", a: "نعم. نستلم البضاعة من مورّديك في الصين، ونطابقها مع فاتورتك، ثم نشحنها إلى سوريا بحراً أو جوّاً. ويمكننا جمع طلبات عدّة موردين في شحنة واحدة." },
        { q: "كيف أتتبّع شحنتي؟", a: "أدخل رقم التتبّع المكوّن من ١٠ أرقام والموجود على الإيصال أو في رسالة واتساب في خانة التتبّع على صفحتنا الرئيسية. سترى المرحلة الحالية والمسار وموعد الوصول المتوقّع." },
        { q: "هل تتولّون التخليص الجمركي في سوريا؟", a: "نعم. فريق التخليص لدينا يجهّز الأوراق قبل وصول البضاعة إلى الحدود، وهذا يوفّر الوقت ويجنّبك تكاليف إضافية." },
        { q: "كيف أحصل على سعر؟", a: "أرسل لنا نوع البضاعة ووزنها أو حجمها ومن أين ستُشحن، عبر نموذج التواصل أو واتساب أو اتصال هاتفي. نرد عليك بسعر واضح يشمل جميع الرسوم." },
      ],
    },
    cities: {
      istanbul: "إسطنبول", damascus: "دمشق", aleppo: "حلب", guangzhou: "غوانزو",
      yiwu: "ييوو", shanghai: "شنغهاي", shenzhen: "شنجن", mersin: "مرسين", gaziantep: "غازي عنتاب",
      latakia: "اللاذقية", homs: "حمص", china: "الصين", turkey: "تركيا", syria: "سوريا",
    },
  },

  en: {
    media: { dockAlt: "A truck leaving the loading dock of our warehouse" },
    nav: { track: "Track" },
    hero: {
      kicker: "Türkiye & China to Syria",
      headline: ["Your safe route", "for trade & shipping"],
      lede: "We pick up your goods from the supplier, pack them in our warehouses and bring them to Damascus and Aleppo. You can see where they are at every step.",
      ctaTrack: "Track a shipment",
      scroll: "Scroll to follow the route",
    },
    track: {
      kicker: "Live tracking",
      title: "Where is your shipment now?",
      subtitle: "Enter the 10-digit tracking number from your shipment receipt or WhatsApp message.",
      label: "Tracking number",
      placeholder: "0000000000",
      button: "Track",
      searching: "Finding your shipment…",
      privacy: "Anyone with the tracking number can see these details, so share it only with people you trust. We never show phone numbers or addresses.",
      digitsHint: (n) => `${n} of 10 digits`,
      errors: {
        invalid: "A tracking number is exactly 10 digits.",
        not_found: "We couldn't find a shipment with that number. Check the digits or contact your nearest branch.",
        rate_limited: "Too many attempts in a short time. Please try again in a few minutes.",
        error: "The tracking system can't be reached right now. Try again shortly or call us.",
      },
      result: {
        shipment: "Shipment",
        current: "Right now",
        from: "From",
        to: "To",
        mode: "Shipping mode",
        eta: "Expected arrival",
        departed: "Departed",
        parcels: "Parcels",
        parcelsOf: (done, total) => `${done} of ${total} arrived`,
        noParcels: "Awaiting receipt",
        lastUpdate: "Last update",
        trackAnother: "Track another number",
        copyLink: "Copy tracking link",
        copied: "Copied",
        cancelled: "This shipment was cancelled",
        cancelledNote: "For questions, contact the branch that registered it.",
        help: "Questions about this shipment?",
        whatsapp: "Message us on WhatsApp",
        domestic: "Domestic",
        unknownCity: "To be confirmed",
        pending: "To be confirmed",
      },
      stages: ["Registered", "At our warehouse", "On the way", "Arrived", "Delivered"],
      details: {
        registered: "Registered. Waiting for your goods to reach our warehouse",
        received: "Received and checked at our warehouse",
        ready_to_ship: "Assigned to a trip, ready to depart",
        loaded: "Loaded and sealed for departure",
        departed: "Departed and on the way",
        at_border: "At the border crossing",
        in_customs: "In customs clearance",
        arrived: "Arrived at our destination warehouse",
        delivered: "Delivered",
      },
      modes: { road: "Road", sea: "Sea", air: "Air" },
      more: {
        sender: "Sender",
        receiver: "Receiver",
        reference: "Shipment no.",
        kind: "Service",
        kinds: { road: "Road freight", sea_lcl: "Sea · shared container", sea_fcl: "Sea · full container", air: "Air freight" },
        payment: "Payment",
        payStatus: { paid: "Paid in full", partial: "Partially paid", unpaid: "Unpaid", pending: "Price being prepared", awaiting_confirmation: "Waiting for your price approval", cancelled: "Cancelled" },
        remaining: "Amount due",
        allPaid: "Nothing left to pay",
        pendingNote: "We will send the final price once your goods are received and weighed at our warehouse.",
        awaitingNote: "Contact us to confirm the final price so we can move your shipment on.",
        paidOf: (paid, total) => `${paid} paid of ${total}`,
        freight: "Shipping",
        customs: "Customs duty",
        customsEst: "estimated",
        customsActual: "actual",
        goodsAdvance: "Goods paid on your behalf",
        other: "Other charges",
        total: "Total",
        paid: "Paid",
        credit: "Credit in your favour",
        dueBy: (d) => `Due by ${d}`,
        payHelp: "To pay or ask about your invoice",
        contents: "What is inside",
        parcelsCount: (n) => (n === 1 ? "1 parcel" : `${n} parcels`),
        multiNote: (n) => `Your shipment has ${n} parcels, all tracked together under one number.`,
        pieces: "pcs",
        kg: "kg",
        cbm: "m³",
        unspecified: "Mixed goods",
        delivered: (d, n) => `${d} of ${n} delivered`,
        showAll: (n) => `Show all items (${n})`,
        showLess: "Show less",
        origin: "Country of origin",
        cancelReason: "Reason",
      },
      demo: "Try locally:",
    },
    journey: {
      kicker: "Your shipment's journey",
      title: "Two origins, one destination",
      chapters: [
        { k: "Pickup", t: "Collected at the source", d: "From factories in China and markets in Istanbul, our team collects your goods and checks them against your invoice." },
        { k: "Warehouse", t: "Consolidated & repacked", d: "Orders from several suppliers become one shipment, repacked to stay protected at every stage." },
        { k: "On the way", t: "By road, sea or air", d: "Road from Türkiye in 5–7 days, sea for heavy loads, air for urgent goods in 2–10 days." },
        { k: "Customs", t: "Cleared without waiting", d: "A dedicated clearance team prepares the paperwork ahead, so your cargo crosses the border on time." },
        { k: "Delivery", t: "In Damascus & Aleppo", d: "Your goods arrive at our warehouses in Damascus and Aleppo, and your tracking number shows you every step." },
      ],
      cta: "Track your shipment",
      progress: "Journey progress",
    },
    proof: {
      before: "In",
      years: "9 years",
      mid1: "we have delivered",
      shipments: "12,400+",
      mid2: "shipments across",
      routes: "18",
      mid3: "routes for",
      clients: "3,200+",
      after: "clients who trust us.",
      ontime: "on-time delivery",
    },
    cta: {
      title: "Ready for your next shipment?",
      body: "Tell us what you're shipping and where from. We'll send you a clear price with no hidden fees.",
      quote: "Get a quote",
      whatsapp: "WhatsApp",
    },
    modesSection: {
      kicker: "Shipping options",
      title: "Pick how your goods travel",
      lede: "Every shipment is different. Here is how our three options compare, so you can choose by budget and by deadline.",
      labels: { route: "Route", transit: "Transit time", bestFor: "Best for", cta: "Ask for a price" },
      items: {
        road: { name: "Road", route: ["Istanbul", "Aleppo", "Damascus"], transit: "5 to 7 days", best: ["Regular orders from Türkiye", "The lowest cost per kilo", "Mixed goods from several suppliers"] },
        sea: { name: "Sea", route: ["China or Mersin", "Latakia", "Damascus"], transit: "10 to 35 days", best: ["Heavy and bulky cargo", "Full or shared containers", "Imports straight from China"] },
        air: { name: "Air", route: ["Istanbul or China", "Damascus"], transit: "2 to 10 days", best: ["Urgent orders", "Small, high-value goods", "Samples and spare parts"] },
      },
    },
    answers: {
      title: "Quick answers",
      items: [
        { q: "How long does shipping from Türkiye to Syria take?", a: "By road it usually takes 5 to 7 days from Istanbul to Damascus or Aleppo. Air freight takes 2 to 10 days. Sea freight takes longer but costs less for heavy cargo." },
        { q: "Can I ship from China to Syria with Misk Cargo?", a: "Yes. We collect your goods from suppliers in China, check them against your invoice and ship them to Syria by sea or air. We can also combine orders from several suppliers into one shipment." },
        { q: "How do I track my shipment?", a: "Type the 10-digit tracking number from your receipt or WhatsApp message into the tracking box on our home page. You will see the current stage, the route and the expected arrival date." },
        { q: "Do you handle customs clearance in Syria?", a: "Yes. Our clearance team prepares the documents before your goods reach the border, which saves time and avoids extra costs." },
        { q: "How do I get a price?", a: "Tell us what you want to ship, its weight or size and where it is coming from, using the contact form, WhatsApp or a phone call. We reply with a clear price and no hidden fees." },
      ],
    },
    cities: {
      istanbul: "Istanbul", damascus: "Damascus", aleppo: "Aleppo", guangzhou: "Guangzhou",
      yiwu: "Yiwu", shanghai: "Shanghai", shenzhen: "Shenzhen", mersin: "Mersin", gaziantep: "Gaziantep",
      latakia: "Latakia", homs: "Homs", china: "China", turkey: "Türkiye", syria: "Syria",
    },
  },

  tr: {
    media: { dockAlt: "Depomuzun yükleme rampasından çıkan bir kamyon" },
    nav: { track: "Takip" },
    hero: {
      kicker: "Türkiye ve Çin'den Suriye'ye",
      headline: ["Ticaret ve kargo için", "güvenli rotanız"],
      lede: "Mallarınızı tedarikçiden alıyor, depolarımızda hazırlıyor ve Şam ile Halep'e getiriyoruz. Nerede olduklarını her an görebilirsiniz.",
      ctaTrack: "Gönderi takibi",
      scroll: "Rotayı izlemek için kaydırın",
    },
    track: {
      kicker: "Canlı takip",
      title: "Gönderiniz şu an nerede?",
      subtitle: "Gönderi makbuzunuzdaki veya WhatsApp mesajınızdaki 10 haneli takip numarasını girin.",
      label: "Takip numarası",
      placeholder: "0000000000",
      button: "Takip et",
      searching: "Gönderiniz aranıyor…",
      privacy: "Takip numarasına sahip herkes bu bilgileri görebilir; numarayı yalnızca güvendiğiniz kişilerle paylaşın. Telefon ve adres asla gösterilmez.",
      digitsHint: (n) => `10 haneden ${n}`,
      errors: {
        invalid: "Takip numarası tam olarak 10 hanedir.",
        not_found: "Bu numarayla bir gönderi bulamadık. Rakamları kontrol edin veya en yakın şubeye ulaşın.",
        rate_limited: "Kısa sürede çok fazla deneme. Lütfen birkaç dakika sonra tekrar deneyin.",
        error: "Takip sistemine şu an ulaşılamıyor. Biraz sonra tekrar deneyin veya bizi arayın.",
      },
      result: {
        shipment: "Gönderi",
        current: "Şu an",
        from: "Nereden",
        to: "Nereye",
        mode: "Taşıma şekli",
        eta: "Tahmini varış",
        departed: "Çıkış",
        parcels: "Koliler",
        parcelsOf: (done, total) => `${total} koliden ${done} ulaştı`,
        noParcels: "Teslim alınması bekleniyor",
        lastUpdate: "Son güncelleme",
        trackAnother: "Başka numara takip et",
        copyLink: "Takip bağlantısını kopyala",
        copied: "Kopyalandı",
        cancelled: "Bu gönderi iptal edildi",
        cancelledNote: "Sorularınız için gönderiyi kaydeden şubeyle iletişime geçin.",
        help: "Bu gönderiyle ilgili sorunuz mu var?",
        whatsapp: "WhatsApp'tan yazın",
        domestic: "Yurt içi",
        unknownCity: "Belirlenecek",
        pending: "Belirlenecek",
      },
      stages: ["Kaydedildi", "Depomuzda", "Yolda", "Ulaştı", "Teslim edildi"],
      details: {
        registered: "Kaydedildi. Malların depomuza ulaşması bekleniyor",
        received: "Depomuzda teslim alındı ve kontrol edildi",
        ready_to_ship: "Bir sefere atandı, yola çıkmaya hazır",
        loaded: "Yüklendi ve mühürlendi",
        departed: "Yola çıktı",
        at_border: "Sınır kapısında",
        in_customs: "Gümrük işlemlerinde",
        arrived: "Varış depomuza ulaştı",
        delivered: "Teslim edildi",
      },
      modes: { road: "Kara", sea: "Deniz", air: "Hava" },
      more: {
        sender: "Gönderen",
        receiver: "Alıcı",
        reference: "Gönderi no.",
        kind: "Hizmet",
        kinds: { road: "Karayolu", sea_lcl: "Deniz · parsiyel konteyner", sea_fcl: "Deniz · komple konteyner", air: "Havayolu" },
        payment: "Ödeme",
        payStatus: { paid: "Tamamı ödendi", partial: "Kısmen ödendi", unpaid: "Ödenmedi", pending: "Fiyat hazırlanıyor", awaiting_confirmation: "Fiyat onayınız bekleniyor", cancelled: "İptal edildi" },
        remaining: "Kalan tutar",
        allPaid: "Ödenecek tutar yok",
        pendingNote: "Mallarınız depomuza ulaşıp tartıldıktan sonra kesin fiyatı göndereceğiz.",
        awaitingNote: "Gönderinizin devam etmesi için kesin fiyatı onaylamak üzere bize ulaşın.",
        paidOf: (paid, total) => `${total} tutarın ${paid} kadarı ödendi`,
        freight: "Navlun",
        customs: "Gümrük vergisi",
        customsEst: "tahmini",
        customsActual: "kesin",
        goodsAdvance: "Sizin adınıza ödenen mal bedeli",
        other: "Diğer masraflar",
        total: "Toplam",
        paid: "Ödenen",
        credit: "Lehinize bakiye",
        dueBy: (d) => `Son ödeme: ${d}`,
        payHelp: "Ödeme veya fatura sorularınız için",
        contents: "Gönderi içeriği",
        parcelsCount: (n) => `${n} koli`,
        multiNote: (n) => `Gönderiniz ${n} koliden oluşuyor ve tek bir numarayla birlikte takip ediliyor.`,
        pieces: "adet",
        kg: "kg",
        cbm: "m³",
        unspecified: "Karışık ürünler",
        delivered: (d, n) => `${n} koliden ${d} teslim edildi`,
        showAll: (n) => `Tüm kalemleri göster (${n})`,
        showLess: "Daha az göster",
        origin: "Menşe ülke",
        cancelReason: "İptal nedeni",
      },
      demo: "Yerel deneme:",
    },
    journey: {
      kicker: "Gönderinizin yolculuğu",
      title: "İki çıkış noktası, tek varış",
      chapters: [
        { k: "Teslim alma", t: "Kaynağında teslim alınır", d: "Çin'deki fabrikalardan ve İstanbul'daki pazarlardan ekibimiz mallarınızı alır ve faturanızla karşılaştırır." },
        { k: "Depo", t: "Birleştirilir ve paketlenir", d: "Birden fazla tedarikçinin siparişleri tek gönderi olur, her aşamada korunacak şekilde yeniden paketlenir." },
        { k: "Yolda", t: "Kara, deniz veya hava", d: "Türkiye'den karayoluyla 5–7 gün, ağır yükler için deniz, acil gönderiler için 2–10 günde hava." },
        { k: "Gümrük", t: "Beklemeden gümrük", d: "Uzman gümrük ekibimiz evrakı önceden hazırlar, yükünüz sınırı zamanında geçer." },
        { k: "Teslimat", t: "Şam ve Halep'te", d: "Mallarınız Şam ve Halep'teki depolarımıza ulaşır; her adımı takip numaranızla izlersiniz." },
      ],
      cta: "Gönderinizi takip edin",
      progress: "Yolculuk ilerlemesi",
    },
    proof: {
      before: "",
      years: "9 yılda",
      mid1: "",
      shipments: "12.400+",
      mid2: "gönderiyi",
      routes: "18",
      mid3: "hat üzerinden, bize güvenen",
      clients: "3.200+",
      after: "müşteriye ulaştırdık.",
      ontime: "zamanında teslimat",
    },
    cta: {
      title: "Sıradaki gönderinize hazır mısınız?",
      body: "Ne gönderdiğinizi ve nereden olduğunu söyleyin; gizli ücret olmadan net bir teklif gönderelim.",
      quote: "Teklif alın",
      whatsapp: "WhatsApp",
    },
    modesSection: {
      kicker: "Taşıma seçenekleri",
      title: "Mallarınız nasıl yolculuk etsin?",
      lede: "Her gönderi farklıdır. Üç seçeneğimizi yan yana koyduk, bütçenize ve sürenize göre seçin.",
      labels: { route: "Güzergâh", transit: "Varış süresi", bestFor: "En uygun olduğu", cta: "Bu seçenek için fiyat iste" },
      items: {
        road: { name: "Kara", route: ["İstanbul", "Halep", "Şam"], transit: "5 ila 7 gün", best: ["Türkiye'den düzenli siparişler", "Kilo başına en düşük maliyet", "Birden fazla tedarikçiden karışık yük"] },
        sea: { name: "Deniz", route: ["Çin veya Mersin", "Lazkiye", "Şam"], transit: "10 ila 35 gün", best: ["Ağır ve hacimli yükler", "Tam veya paylaşımlı konteyner", "Çin'den doğrudan ithalat"] },
        air: { name: "Hava", route: ["İstanbul veya Çin", "Şam"], transit: "2 ila 10 gün", best: ["Acil siparişler", "Küçük ve değerli ürünler", "Numuneler ve yedek parçalar"] },
      },
    },
    answers: {
      title: "Kısa cevaplar",
      items: [
        { q: "Türkiye'den Suriye'ye kargo ne kadar sürer?", a: "Karayoluyla İstanbul'dan Şam veya Halep'e genellikle 5 ila 7 gün sürer. Hava kargo 2 ila 10 gün sürer. Deniz yolu daha uzun sürer ama ağır yükler için daha ucuzdur." },
        { q: "Misk Cargo ile Çin'den Suriye'ye gönderi yapabilir miyim?", a: "Evet. Mallarınızı Çin'deki tedarikçilerden alır, faturanızla karşılaştırır ve deniz veya hava yoluyla Suriye'ye göndeririz. Birden fazla tedarikçinin siparişini tek gönderide birleştirebiliriz." },
        { q: "Gönderimi nasıl takip ederim?", a: "Makbuzunuzdaki veya WhatsApp mesajınızdaki 10 haneli takip numarasını ana sayfamızdaki takip kutusuna yazın. Mevcut aşamayı, güzergâhı ve tahmini varış tarihini görürsünüz." },
        { q: "Suriye'de gümrük işlemlerini siz mi yapıyorsunuz?", a: "Evet. Gümrük ekibimiz evrakı mallarınız sınıra varmadan hazırlar. Bu hem zaman kazandırır hem de ek masrafları önler." },
        { q: "Nasıl fiyat alırım?", a: "Ne göndermek istediğinizi, ağırlığını veya hacmini ve nereden geleceğini iletişim formu, WhatsApp veya telefonla bize bildirin. Gizli ücret olmadan net bir fiyatla dönüş yaparız." },
      ],
    },
    cities: {
      istanbul: "İstanbul", damascus: "Şam", aleppo: "Halep", guangzhou: "Guangzhou",
      yiwu: "Yiwu", shanghai: "Şanghay", shenzhen: "Shenzhen", mersin: "Mersin", gaziantep: "Gaziantep",
      latakia: "Lazkiye", homs: "Humus", china: "Çin", turkey: "Türkiye", syria: "Suriye",
    },
  },

  "zh-CN": {
    media: { dockAlt: "一辆货车驶离我们仓库的装卸平台" },
    nav: { track: "货物追踪" },
    hero: {
      kicker: "土耳其和中国 · 发往叙利亚",
      headline: ["贸易与货运的", "安全通道"],
      lede: "我们从供应商处提货，在自有仓库打包，再送到大马士革和阿勒颇。货物到了哪里，您随时可以查看。",
      ctaTrack: "追踪货物",
      scroll: "向下滚动，跟随路线",
    },
    track: {
      kicker: "实时追踪",
      title: "您的货物现在在哪里？",
      subtitle: "请输入运单收据或 WhatsApp 消息中的 10 位追踪号码。",
      label: "追踪号码",
      placeholder: "0000000000",
      button: "查询",
      searching: "正在查找您的货物…",
      privacy: "任何拥有追踪号的人都能看到这些信息，请只与信任的人分享。我们从不显示电话号码或地址。",
      digitsHint: (n) => `已输入 ${n} / 10 位`,
      errors: {
        invalid: "追踪号码必须正好是 10 位数字。",
        not_found: "未找到该号码对应的货物。请核对号码或联系最近的分公司。",
        rate_limited: "短时间内尝试次数过多，请几分钟后再试。",
        error: "暂时无法连接追踪系统，请稍后重试或致电我们。",
      },
      result: {
        shipment: "货物",
        current: "当前状态",
        from: "起运地",
        to: "目的地",
        mode: "运输方式",
        eta: "预计到达",
        departed: "发运日期",
        parcels: "包裹",
        parcelsOf: (done, total) => `${total} 件中已到 ${done} 件`,
        noParcels: "等待入仓",
        lastUpdate: "最后更新",
        trackAnother: "查询其他号码",
        copyLink: "复制追踪链接",
        copied: "已复制",
        cancelled: "该货物已取消",
        cancelledNote: "如有疑问，请联系登记该货物的分公司。",
        help: "对这批货物有疑问？",
        whatsapp: "通过 WhatsApp 联系我们",
        domestic: "国内运输",
        unknownCity: "待定",
        pending: "待定",
      },
      stages: ["已登记", "已入仓", "运输中", "已到达", "已签收"],
      details: {
        registered: "已登记，等待货物到达我们的仓库",
        received: "已在我们仓库签收并检查",
        ready_to_ship: "已分配车次，准备出发",
        loaded: "已装载封箱，准备发运",
        departed: "已发运，运输途中",
        at_border: "抵达边境口岸",
        in_customs: "清关中",
        arrived: "已到达目的地仓库",
        delivered: "已签收",
      },
      modes: { road: "陆运", sea: "海运", air: "空运" },
      more: {
        sender: "发件人",
        receiver: "收件人",
        reference: "货运单号",
        kind: "运输方式",
        kinds: { road: "陆运", sea_lcl: "海运 · 拼箱", sea_fcl: "海运 · 整箱", air: "空运" },
        payment: "付款",
        payStatus: { paid: "已全额付款", partial: "部分付款", unpaid: "未付款", pending: "报价准备中", awaiting_confirmation: "等待您确认价格", cancelled: "已取消" },
        remaining: "待付金额",
        allPaid: "无待付金额",
        pendingNote: "货物到达我们仓库并称重后，我们会发送最终价格。",
        awaitingNote: "请联系我们确认最终价格，以便继续处理您的货物。",
        paidOf: (paid, total) => `已付 ${paid}，共 ${total}`,
        freight: "运费",
        customs: "关税",
        customsEst: "预估",
        customsActual: "实际",
        goodsAdvance: "代您支付的货款",
        other: "其他费用",
        total: "合计",
        paid: "已付",
        credit: "您的余额",
        dueBy: (d) => `请于 ${d} 前付款`,
        payHelp: "付款或咨询账单",
        contents: "货物内容",
        parcelsCount: (n) => `${n} 件包裹`,
        multiNote: (n) => `您的货物共有 ${n} 件包裹，使用同一个追踪号一起追踪。`,
        pieces: "件",
        kg: "公斤",
        cbm: "立方米",
        unspecified: "混合货物",
        delivered: (d, n) => `已交付 ${d}/${n}`,
        showAll: (n) => `显示全部货物（${n}）`,
        showLess: "收起",
        origin: "原产国",
        cancelReason: "取消原因",
      },
      demo: "本地测试：",
    },
    journey: {
      kicker: "货物的旅程",
      title: "两个起点，一个终点",
      chapters: [
        { k: "提货", t: "源头提货", d: "从中国的工厂到伊斯坦布尔的市场，我们的团队上门提货，并与您的发票逐项核对。" },
        { k: "仓储", t: "集货与重新包装", d: "多家供应商的订单合并为一票货物，重新包装，确保每个环节都安全。" },
        { k: "运输", t: "陆运、海运或空运", d: "土耳其陆运 5–7 天，大宗货物走海运，紧急货物空运 2–10 天。" },
        { k: "清关", t: "高效清关", d: "专业清关团队提前准备单证，让您的货物准时通过边境。" },
        { k: "交付", t: "大马士革与阿勒颇", d: "货物抵达我们在大马士革和阿勒颇的仓库，您可凭追踪号码查看每一步。" },
      ],
      cta: "追踪您的货物",
      progress: "旅程进度",
    },
    proof: {
      before: "",
      years: "9 年来",
      mid1: "，我们通过",
      shipments: "12,400+",
      mid2: "票货物、",
      routes: "18",
      mid3: "条线路，服务了",
      clients: "3,200+",
      after: "位信赖我们的客户。",
      ontime: "准时交付率",
    },
    cta: {
      title: "准备好发运下一批货物了吗？",
      body: "告诉我们您要运什么、从哪里发货，我们会给您一个清楚的报价，没有隐藏费用。",
      quote: "获取报价",
      whatsapp: "WhatsApp",
    },
    modesSection: {
      kicker: "运输方式",
      title: "选择货物的运输方式",
      lede: "每票货物情况不同。下面是三种方式的对比，您可以按预算和时间来选择。",
      labels: { route: "线路", transit: "运输时间", bestFor: "适合", cta: "咨询这种方式的价格" },
      items: {
        road: { name: "陆运", route: ["伊斯坦布尔", "阿勒颇", "大马士革"], transit: "5 至 7 天", best: ["来自土耳其的常规订单", "每公斤成本最低", "多家供应商的混合货物"] },
        sea: { name: "海运", route: ["中国或梅尔辛", "拉塔基亚", "大马士革"], transit: "10 至 35 天", best: ["重货和大件货物", "整箱或拼箱", "从中国直接进口"] },
        air: { name: "空运", route: ["伊斯坦布尔或中国", "大马士革"], transit: "2 至 10 天", best: ["紧急订单", "小件高价值货物", "样品和零配件"] },
      },
    },
    answers: {
      title: "常见问题速答",
      items: [
        { q: "从土耳其到叙利亚运输需要多久？", a: "陆运从伊斯坦布尔到大马士革或阿勒颇通常需要 5 至 7 天。空运需要 2 至 10 天。海运时间更长，但重货成本更低。" },
        { q: "可以通过 Misk Cargo 从中国发货到叙利亚吗？", a: "可以。我们从您在中国的供应商处提货，与发票逐项核对，再通过海运或空运发往叙利亚。我们也可以把多家供应商的订单合并成一票货物。" },
        { q: "如何追踪我的货物？", a: "在我们首页的追踪框中输入收据或 WhatsApp 消息里的 10 位追踪号码，即可看到当前阶段、线路和预计到达日期。" },
        { q: "你们负责叙利亚的清关吗？", a: "负责。我们的清关团队会在货物到达边境前准备好单证，既节省时间，又避免额外费用。" },
        { q: "如何获取报价？", a: "通过联系表单、WhatsApp 或电话告诉我们货物类型、重量或体积以及发货地，我们会给您一个清楚的报价，没有隐藏费用。" },
      ],
    },
    cities: {
      istanbul: "伊斯坦布尔", damascus: "大马士革", aleppo: "阿勒颇", guangzhou: "广州",
      yiwu: "义乌", shanghai: "上海", shenzhen: "深圳", mersin: "梅尔辛", gaziantep: "加济安泰普",
      latakia: "拉塔基亚", homs: "霍姆斯", china: "中国", turkey: "土耳其", syria: "叙利亚",
    },
  },
};

/* Warehouse cities arrive from the ERP in whatever language staff typed them.
   Map common spellings to a stable key so the tracker can localise them. */
const CITY_ALIASES = {
  istanbul: ["istanbul", "i̇stanbul", "إسطنبول", "اسطنبول", "伊斯坦布尔", "basaksehir", "başakşehir"],
  damascus: ["damascus", "şam", "دمشق", "大马士革", "zablatani", "الزبلطاني"],
  aleppo: ["aleppo", "halep", "حلب", "阿勒颇", "nuqarin", "النقارين"],
  guangzhou: ["guangzhou", "canton", "غوانزو", "غوانغجو", "广州"],
  yiwu: ["yiwu", "ييوو", "إيوو", "义乌"],
  shanghai: ["shanghai", "şanghay", "شنغهاي", "上海"],
  shenzhen: ["shenzhen", "شنجن", "شنتشن", "深圳"],
  mersin: ["mersin", "مرسين", "梅尔辛"],
  gaziantep: ["gaziantep", "antep", "عنتاب", "加济安泰普"],
  latakia: ["latakia", "lazkiye", "اللاذقية", "拉塔基亚"],
  homs: ["homs", "humus", "حمص", "霍姆斯"],
};

/* Strip Latin diacritics (İ→i, ş→s) and case, leave Arabic / CJK intact. */
const fold = (s) => String(s).normalize("NFKD").replace(/[̀-ͯ]/g, "").toLowerCase().trim();

export function cityKey(raw) {
  if (!raw) return null;
  const v = fold(raw);
  for (const [key, names] of Object.entries(CITY_ALIASES)) {
    if (names.some((n) => v.includes(fold(n)))) return key;
  }
  return null;
}

export function localCity(raw, cities) {
  const key = cityKey(raw);
  return key && cities?.[key] ? cities[key] : raw || null;
}
